import { render, staticRenderFns } from "./oauthList.vue?vue&type=template&id=d01fe1a4&scoped=true&"
import script from "./oauthList.vue?vue&type=script&lang=js&"
export * from "./oauthList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01fe1a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d01fe1a4')) {
      api.createRecord('d01fe1a4', component.options)
    } else {
      api.reload('d01fe1a4', component.options)
    }
    module.hot.accept("./oauthList.vue?vue&type=template&id=d01fe1a4&scoped=true&", function () {
      api.rerender('d01fe1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/oauthList.vue"
export default component.exports